/**
 * @module "view/form.object/content/base.selectable.content.view"
 */

define('formkit/view/form.object/content/base.selectable.content.view',['require','exports','module','underscore','uikit/uikit','./base.content.view','../../../behavior/template.object.reorder.drag.drop.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                                     = require('underscore'),
      UIKit                                 = require('uikit/uikit'),
      BaseContentView                       = require('./base.content.view'),
      TemplateObjectReorderDragDropBehavior = require('../../../behavior/template.object.reorder.drag.drop.behavior');

  var DesignAnswerItemView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="formView" />';
    },

    internalViewOptions: {
      formView: {
        type: UIKit.Form,
      },
      labelInputView: function() {
        return {
          type: UIKit.Input,
          placeholder: 'Label',
          model: this.model,
          bindings: {
            value: 'text',
          },
        };
      },
      addButtonView: function() {
        return {
          type: UIKit.Button,
          collection: this.model,
          icon: 'add',
        };
      },
      removeButtonView: function() {
        return {
          type: UIKit.Button,
          collection: this.model,
          icon: 'minus',
        };
      },
    },

    onInjectedFormView: function() {
      this.setupForm();
    },

    setupForm: function() {
      var buttonContainerView = new UIKit.Container({
        className: 'ui buttons',
      });

      buttonContainerView.add((this.addButtonView = this.buildComponent({ name: 'addButtonView' })));
      buttonContainerView.add((this.removeButtonView = this.buildComponent({ name: 'removeButtonView' })));

      this.formView
        .addGroup()
        .addField({ width: 12, text: '' }, this.buildComponent({ name: 'labelInputView' }))
        .parent()
        .addField({ width: 4 }, buttonContainerView)
        .parent();

      this.setupAddButtonView();
      this.setupRemoveButtonView();
    },

    setupAddButtonView: function() {
      this.listenTo(this.addButtonView, 'press', function() {
        var parentModel = this.form.util.parent(this.model);
        var childTemplateObject = this.form.getContentViewOption(
          this.form.getTemplateObjectTypeName(parentModel),
          'childTemplateObject'
        );
        this.form.insertTemplateObject(parentModel, childTemplateObject);
      });

      return this;
    },

    setupRemoveButtonView: function() {
      this.listenTo(this.removeButtonView, 'press', function() {
        this.form.detachTemplateObject(this.model);
      });

      return this;
    },
  });

  var DesignAnswerCollectionView = UIKit.CollectionView.extend({
    childView: DesignAnswerItemView,
    childViewOptions: function() {
      return {
        form: this.form,
      };
    },
  });

  var DesignAnswerView = UIKit.ItemView.extend({
    internalViewOptions: {
      collectionView: function() {
        return {
          type: DesignAnswerCollectionView,
          form: this.form,
          model: this.model,
          bindings: {
            collection: 'children',
          },
          behaviors: {
            TemplateObjectCollectionDragDrop: {
              behaviorClass: TemplateObjectReorderDragDropBehavior,
            },
          },
        };
      },
    },

    modelEvents: {
      'remove:child': 'insertModelOnEmptyCollection',
    },

    /**
     * @todo Debounce is necessary due to problem with CheckboxGroup View
     * not updating properly upon removal from/addition to the collection.
     */

    insertModelOnEmptyCollection: _.debounce(function() {
      if (!this.form.util.hasChildren(this.model)) {
        var childTemplateObject = this.form.getContentViewOption(
          this.form.getTemplateObjectTypeName(this.model),
          'childTemplateObject'
        );
        this.form.insertTemplateObject(this.model, childTemplateObject);
      }
    }),
  });

  var PreviewAnswerView = UIKit.ItemView.extend({
    options: {
      readonly: false,
      comparing: false,
    },

    internalViewBindings: {
      groupView: {
        readonly: 'readonly',
        comparing: 'comparing',
      },
    },

    internalViewOptions: {
      groupView: function() {
        return {
          form: this.form,
          model: this.model,
          bindings: {
            collection: 'children',
          },
          childBindings: {
            text: 'text',
          },
          readonly: this.getOption('readonly'),
          comparing: this.getOption('comparing'),
        };
      },
    },

    /**
     * getAndLinkAnswerValueModel
     *
     * @param  {Object} model
     * @param  {Objbect} form
     * @returns {Object} answerValueModel
     */

    getAndLinkAnswerValueModel: function(model, form) {
      var defaultAnswerIndex = this.getAnswerValueIndex();
      return form.getAnswerValueModel(model, defaultAnswerIndex);
    },

    /**
     * Since A Single Value Answer one has one answer per template formObject
     * (ie a checkbox), the index of such should always be 0.
     *
     * @return {number} The answer value index of 0.
     */
    getAnswerValueIndex: function() {
      return 0;
    },
  });

  var BaseSelectableContentView = BaseContentView.extend({
    internalViewOptions: BaseContentView.extendInternalViewOptions({
      designAnswerView: function() {
        return {
          type: DesignAnswerView,
          form: this.form,
          model: this.model,
        };
      },
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
          form: this.form,
          model: this.model,
          comparing: this.getOption('comparing'),
        };
      },
    }),
  });

  BaseSelectableContentView.DesignAnswerItemView = DesignAnswerItemView;
  BaseSelectableContentView.DesignAnswerCollectionView = DesignAnswerCollectionView;
  BaseSelectableContentView.DesignAnswerView = DesignAnswerView;
  BaseSelectableContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = BaseSelectableContentView;
});

